import {combineReducers} from 'redux';
import auth from './auth';
import invitation from './invitation';
import guests from './guests';
import dietary from './dietary';
import translations from './translations';
import general from './general';
import redirect from './redirect';

export default combineReducers({
    general,
    auth,
    invitation,
    guests,
    dietary,
    translations,
    redirect,
});
